

export const COUNTRIES = [{ name: 'España', value: 'ES'}]

export const PROVINCES = { 'ES' : [{name: 'A Coruña', value: 'A Coruña'},
                {name: 'Alacant', value: 'Alacant'},
                {name: 'Álava', value: 'Álava'},
                {name: 'Albacete', value: 'Albacete'},
                {name: 'Almería', value: 'Almería'},
                {name: 'Asturias', value: 'Asturias'},
                {name: 'Ávila', value: 'Ávila'},
                {name: 'Badajoz', value: 'Badajoz'},
                {name: 'Barcelona', value: 'Barcelona'},
                {name: 'Bizkaia', value: 'Bizkaia'},
                {name: 'Burgos', value: 'Burgos'},
                {name: 'Cáceres', value: 'Cáceres'},
                {name: 'Cádiz', value: 'Cádiz'},
                {name: 'Cantabria', value: 'Cantabria'},
                {name: 'Castelló', value: 'Castelló'},
                {name: 'Ceuta', value: 'Ceuta'},
                {name: 'Ciudad Real', value: 'Ciudad Real'},
                {name: 'Córdoba', value: 'Córdoba'},
                {name: 'Cuenca', value: 'Cuenca'},
                {name: 'Gipuzkoa', value: 'Gipuzkoa'},
                {name: 'Girona', value: 'Girona'},
                {name: 'Granada', value: 'Granada'},
                {name: 'Guadalajara', value: 'Guadalajara'},
                {name: 'Huelva', value: 'Huelva'},
                {name: 'Huesca', value: 'Huesca'},
                {name: 'Illes Balears', value: 'Illes Balears'},
                {name: 'Jaén', value: 'Jaén'},
                {name: 'La Rioja', value: 'La Rioja'},
                {name: 'Las Palmas', value: 'Las Palmas'},
                {name: 'León', value: 'León'},
                {name: 'Lleida', value: 'Lleida'},
                {name: 'Lugo', value: 'Lugo'},
                {name: 'Madrid', value: 'Madrid'},
                {name: 'Málaga', value: 'Málaga'},
                {name: 'Melilla', value: 'Melilla'},
                {name: 'Murcia', value: 'Murcia'},
                {name: 'Nafarroa', value: 'Nafarroa'},
                {name: 'Ourense', value: 'Ourense'},
                {name: 'Palencia', value: 'Palencia'},
                {name: 'Pontevedra', value: 'Pontevedra'},
                {name: 'Salamanca', value: 'Salamanca'},
                {name: 'Segovia', value: 'Segovia'},
                {name: 'Sevilla', value: 'Sevilla'},
                {name: 'Soria', value: 'Soria'},
                {name: 'Sta. Cruz de Tenerife', value: 'Sta. Cruz de Tenerife'},
                {name: 'Tarragona', value: 'Tarragona'},
                {name: 'Teruel', value: 'Teruel'},
                {name: 'Toledo', value: 'Toledo'},
                {name: 'Valencia', value: 'Valencia'},
                {name: 'Valladolid', value: 'Valladolid'},
                {name: 'Vila Real', value: 'Vila_Real'},
                {name: 'Zamora', value: 'Zamora'},
                {name: 'Zaragoza', value: 'Zaragoza'},]}